<template>
  <div @click="selectCountry()">
    <small class="label">{{ $l.userCountry }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="country"
      :placeholder="$l.userCountry"
      disabled
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],


  computed: {
    country: function () {
      const country = this.$store.state.user.country
      if (country) {
        return country.get(this.locale)
      }
      return ''
    }
  },

  methods: {
    selectCountry: function () {
      this.$store.dispatch('popup/show', 'user-country')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
